exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n  text-align: center !important;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.5);\n  z-index: 100; }\n  .loader > span {\n    display: inline-block; }\n  .loader p {\n    color: #404950;\n    font-size: 18px;\n    text-shadow: 0 0px 2px white; }\n", ""]);

// exports
